import React from 'react';
import { Container } from './ui/Container';
import { Button } from './ui/Button';
import { X, Check, ArrowRight } from 'lucide-react';
export function ReasonWhySection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-20 bg-gray-50" data-id="element-456">
      <Container data-id="element-457">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-458">
          {/* Left Content */}
          <div data-id="element-459">
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-8 leading-tight" data-id="element-460">
              Why SnoreStop™ Works When Everything Else Failed
            </h2>

            <div className="space-y-4 mb-10" data-id="element-461">
              {[{
              item: 'Nose strips?',
              verdict: 'Temporary nonsense.'
            }, {
              item: 'Sprays?',
              verdict: "Don't fix airflow."
            }, {
              item: 'Special pillows?',
              verdict: 'Gimmicks.'
            }, {
              item: 'CPAP machines?',
              verdict: 'Torture.'
            }].map((comparison, i) => <div key={i} className="flex items-center p-4 bg-white rounded-xl border border-gray-200 shadow-sm" data-id="element-462">
                  <div className="flex-shrink-0 w-8 h-8 rounded-full bg-red-100 flex items-center justify-center mr-4" data-id="element-463">
                    <X className="w-5 h-5 text-red-600" data-id="element-464" />
                  </div>
                  <p className="text-lg text-gray-800" data-id="element-465">
                    <span className="font-bold line-through text-gray-400 mr-2" data-id="element-466">
                      {comparison.item}
                    </span>
                    <span className="font-bold text-red-600" data-id="element-467">
                      {comparison.verdict}
                    </span>
                  </p>
                </div>)}
            </div>

            <div className="bg-blue-900 text-white p-8 rounded-2xl shadow-xl relative overflow-hidden" data-id="element-468">
              <div className="absolute top-0 right-0 w-32 h-32 bg-blue-500 rounded-full blur-3xl opacity-20 transform translate-x-1/2 -translate-y-1/2" data-id="element-469"></div>

              <h3 className="text-xl font-bold mb-4 flex items-center" data-id="element-470">
                <Check className="w-6 h-6 text-green-400 mr-2" data-id="element-471" />
                The Real Solution
              </h3>

              <p className="text-lg leading-relaxed mb-6 text-blue-100" data-id="element-472">
                SnoreStop™ targets the real cause:{' '}
                <span className="text-white font-bold" data-id="element-473">
                  Your airway collapsing while you sleep.
                </span>
              </p>

              <p className="text-lg leading-relaxed mb-8 text-blue-100" data-id="element-474">
                Its jaw-positioning design helps keep your airway open naturally
                — so breathing stays smooth and snoring drops fast.
              </p>

              <div className="flex flex-wrap gap-3 mb-8" data-id="element-475">
                {['No machines', 'No pills', 'No surgery'].map((tag, i) => <span key={i} className="px-3 py-1 bg-blue-800 rounded-full text-sm font-semibold text-blue-200 border border-blue-700" data-id="element-476">
                    {tag}
                  </span>)}
              </div>

              <Button onClick={scrollToPricing} variant="secondary" fullWidth className="shadow-lg shadow-orange-500/20" data-id="element-477">
                Try SnoreStop™ Now
                <ArrowRight className="ml-2 w-5 h-5" data-id="element-478" />
              </Button>
            </div>
          </div>

          {/* Right Visual */}
          <div className="relative flex justify-center items-center" data-id="element-479">
            <div className="absolute inset-0 bg-blue-100 rounded-full filter blur-3xl opacity-50 transform scale-90" data-id="element-480"></div>

            <div className="relative z-10 w-full max-w-md" data-id="element-481">
              <img src="https://cdn.magicpatterns.com/uploads/ckEK2fDVMho2aEzwy1jUxB/imgi_30_1746975295-SnoreStop™_(1).png" alt="SnoreStop Product" className="w-full h-auto drop-shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-482" />

              {/* Floating Feature Cards */}
              <div className="absolute -top-4 -right-4 bg-white p-3 rounded-xl shadow-lg border border-gray-100 animate-bounce" style={{
              animationDuration: '3s'
            }} data-id="element-483">
                <span className="text-sm font-bold text-gray-900" data-id="element-484">
                  🔬 Medical Grade
                </span>
              </div>

              <div className="absolute bottom-10 -left-4 bg-white p-3 rounded-xl shadow-lg border border-gray-100 animate-bounce" style={{
              animationDuration: '4s'
            }} data-id="element-485">
                <span className="text-sm font-bold text-gray-900" data-id="element-486">
                  ✨ BPA Free
                </span>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>;
}